"use client";

import { useEffect, useState } from "react";
import { MAINTENANCE_MODE } from "@/lib/constants";

type MaintenanceResponse = {
  maintenance: boolean;
};

export function useMaintenanceMode(): boolean {
  const [maintenance, setMaintenance] = useState<boolean>(MAINTENANCE_MODE);

  useEffect(() => {
    let active = true;

    fetch("/api/maintenance", { cache: "no-store" })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch maintenance mode");
        return res.json() as Promise<MaintenanceResponse>;
      })
      .then((data) => {
        if (active) setMaintenance(data.maintenance);
      })
      .catch(() => {
        if (active) setMaintenance(MAINTENANCE_MODE);
      });

    return () => {
      active = false;
    };
  }, []);

  return maintenance;
}
